import React from 'react';

interface AaveBannerProps {
    width: number;
}

const AaveBanner: React.FC<AaveBannerProps> = ({ width }) => (
    <svg
        id="Layer_1"
        width={width}
        data-name="Layer 1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 1000 220"
        style={{ verticalAlign: 'middle' }}
    >
        <g id="Group_4051" data-name="Group 4051">
            <path
                id="Path_2431"
                data-name="Path 2431"
                style={{ fill: '#fff' }}
                d="M478.82 203.2L404.08 21.93a15.83 15.83 0 01-.92-5.15 14.29 14.29 0 013.67-10.1 12.88 12.88 0 019.92-3.85 13.34 13.34 0 017.72 2.57 16.27 16.27 0 015.32 6.79l71.07 177.42 71.07-177.42a16.27 16.27 0 015.32-6.79A13.34 13.34 0 01585 2.83a12.86 12.86 0 019.91 3.85 14.25 14.25 0 013.68 10.1 16.31 16.31 0 01-.92 5.14L522.9 203.2c-4.21 9.37-10.47 14-18.74 14h-6.61c-8.26-.04-14.5-4.63-18.73-14z"
            />
            <path
                id="Path_2432"
                data-name="Path 2432"
                style={{ fill: '#fff' }}
                d="M630.33 211.65a13.28 13.28 0 01-3.86-9.74V18.25a14 14 0 013.86-9.91 12.73 12.73 0 019.73-4h121.38a12.09 12.09 0 019.19 3.85 12.39 12.39 0 013.85 9.19 11.66 11.66 0 01-3.85 9 13 13 0 01-9.19 3.62H654v66.87h96.6a12.09 12.09 0 019.18 3.86 12.6 12.6 0 013.85 9.18 11.66 11.66 0 01-3.85 9 12.88 12.88 0 01-9.18 3.67H654v67.22h107.44a12 12 0 019.18 3.86 12.33 12.33 0 013.86 9.18 11.64 11.64 0 01-3.86 9 12.93 12.93 0 01-9.18 3.67H640.06a12 12 0 01-9.73-3.86z"
            />
            <path
                id="Path_2433"
                data-name="Path 2433"
                style={{ fill: '#fff' }}
                d="M421 198.06L346.25 16.78C342 7.42 335.78 2.83 327.51 2.83h-6.62c-8.26 0-14.5 4.59-18.73 14l-32.5 79h-24.61a13.5 13.5 0 00-13.41 13.41v.18a13.49 13.49 0 0013.41 13.41h13.22l-31 75.3a15.81 15.81 0 00-.92 5.14 14.19 14.19 0 003.67 10.1 12.89 12.89 0 009.92 3.86 13.45 13.45 0 007.71-2.57 16.3 16.3 0 005.33-6.8l34.15-85h23.5A13.49 13.49 0 00324 109.35V109a13.48 13.48 0 00-13.4-13.41h-12.67l26.26-65.2 71.07 177.42a16.21 16.21 0 005.33 6.79 13.28 13.28 0 007.71 2.57 12.88 12.88 0 009.92-3.85 14.21 14.21 0 003.67-10.11 12.28 12.28 0 00-.89-5.15z"
            />
            <path
                id="Path_2434"
                data-name="Path 2434"
                style={{ fill: '#fff' }}
                d="M197.67 198.06L122.94 16.78C118.7 7.42 112.46 2.83 104.2 2.83h-6.61c-8.27 0-14.51 4.59-18.74 14l-32.5 79H21.74a13.49 13.49 0 00-13.4 13.41v.18a13.49 13.49 0 0013.4 13.42H35l-31 75.3a15.81 15.81 0 00-1 5.06 14.17 14.17 0 003.67 10.1 12.89 12.89 0 009.92 3.86 13.43 13.43 0 007.71-2.57 16.3 16.3 0 005.33-6.8l34.16-85h23.7a13.49 13.49 0 0013.4-13.41V109a13.48 13.48 0 00-13.4-13.41H74.81l26.08-65.21L172 207.79a16.46 16.46 0 005.33 6.8 13.48 13.48 0 007.72 2.57 12.92 12.92 0 009.92-3.86 14.29 14.29 0 003.67-10.1 12.22 12.22 0 00-.97-5.14z"
            />
        </g>
        <path
            id="Path_7142"
            data-name="Path 7142"
            style={{ fill: '#fff' }}
            d="M973.49 74.89a73.07 73.07 0 00-146.11 0v133.77a8.13 8.13 0 0016.25 0v-23.61a8.12 8.12 0 1116.24 0v11.2a8.12 8.12 0 1016.24 0v-11.2a8.13 8.13 0 018.12-8.12 8.13 8.13 0 018.12 8.12v3.06a8.12 8.12 0 1016.24 0v-3.06a8.13 8.13 0 0116.25 0v11.2a8.12 8.12 0 1016.24 0v-11.2a8.13 8.13 0 018.12-8.12 8.13 8.13 0 018.12 8.12v23.61a8.12 8.12 0 0016.24 0V75.44a3.6 3.6 0 01-.07-.55zm-100 11.69c-7.18 0-13-6.66-13-14.91s5.82-14.91 13-14.91 13 6.67 13 14.91-5.81 14.91-13 14.91zm27.53 21c-6.52 0-11.8-3.88-11.8-8.67s5.28-1.9 11.8-1.9 11.8-2.89 11.8 1.9-5.28 8.67-11.8 8.67zm26.36-21c-7.17 0-13-6.66-13-14.91s5.83-14.91 13-14.91 13 6.67 13 14.91-5.82 14.91-13 14.91z"
        />
        <ellipse
            id="Ellipse_598"
            data-name="Ellipse 598"
            style={{ fill: 'none' }}
            cx="873.5"
            cy="71.67"
            rx="13"
            ry="14.91"
        />
        <path
            id="Path_7143"
            data-name="Path 7143"
            style={{ fill: 'none' }}
            d="M901 97.05c-6.51 0-11.8-2.89-11.8 1.9s5.29 8.67 11.8 8.67 11.8-3.89 11.8-8.67-5.25-1.9-11.8-1.9z"
        />
        <ellipse
            id="Ellipse_599"
            data-name="Ellipse 599"
            style={{ fill: 'none' }}
            cx="927.39"
            cy="71.67"
            rx="13"
            ry="14.91"
        />
        <path
            id="Path_7148"
            data-name="Path 7148"
            style={{ opacity: '.21', isolation: 'isolate' }}
            d="M860.49 71.67s.92-15.94 13-16 13 16 13 16-2.52-14.91-13-14.91c-7.49.02-13.33 11.55-13 14.91z"
        />
        <path
            id="Path_7149"
            data-name="Path 7149"
            style={{ opacity: '.21', isolation: 'isolate' }}
            d="M914.39 71.67s.92-15.94 13-16 13 16 13 16-2.52-14.91-13-14.91c-7.49.02-13.34 11.55-13 14.91z"
        />
        <path
            id="Path_7150"
            data-name="Path 7150"
            style={{ opacity: '.21', isolation: 'isolate' }}
            d="M873.5 53.77c-5.76 0-14.7 6.48-14.7 17.9a15.78 15.78 0 0014.7 16.5c5.57 0 14-5.06 14-16.5s-8.24-17.9-14-17.9zm.19 32.56c-8.15.24-13-8.87-13-15.51a13.09 13.09 0 0112.77-13.42h.23c8.1 0 11.6 6.78 11.6 13.42s-3.44 15.28-11.6 15.51z"
        />
        <path
            id="Path_7151"
            data-name="Path 7151"
            style={{ opacity: '.1', isolation: 'isolate' }}
            d="M927.86 53.77c-5.76 0-14.69 6.48-14.69 17.9a15.77 15.77 0 0014.69 16.5c5.58 0 14-5.06 14-16.5s-8.24-17.9-14-17.9zm.2 32.56c-8.16.24-13-8.87-13-15.51a13.1 13.1 0 0112.77-13.42h.23c8.09 0 11.6 6.78 11.6 13.42s-3.44 15.28-11.6 15.51z"
        />
        <path
            style={{ fill: '#f1f2f2' }}
            d="M966.91 120.87a1.14 1.14 0 00-1.15 1.15v35a1.15 1.15 0 102.3 0V122a1.15 1.15 0 00-1.15-1.13zM966.91 102.74a1.14 1.14 0 00-1.15 1.15V111a1.15 1.15 0 102.3 0v-7.09a1.15 1.15 0 00-1.15-1.17zM834.14 93.85A1.14 1.14 0 00833 95v21.06a1.15 1.15 0 102.29 0V95a1.14 1.14 0 00-1.15-1.15z"
        />
    </svg>
);

export default AaveBanner;
